
export default function reports( state = [], action = {} ){

	switch( action.type ){
		case 'GET_LEAVE_SUMMARY':
			return action.reports
		case 'GET_DEPARTMENT_SUMMARY':
			return action.reports
		case 'GET_COMPANY_SUMMARY':
			return action.reports
		default: return state;
	}
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/reports/reports.reducer.js